import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TimesheetService } from '../../services/timesheet/timesheet.service';
import { DataService } from '../../services/data/data.service';
import { AccountService } from '../../services/account/account.service';
import { ConfigService } from '../../services/config/config.service';
import { HourTypes } from '../../constants';
import _ from 'lodash';

@Component({
	selector: 'pcm-search-accounts',
	templateUrl: './search-accounts.component.html',
	styleUrls: ['./search-accounts.component.scss']
})
export class SearchAccountsComponent implements OnInit {

	@Output() accountChange: EventEmitter<any> = new EventEmitter();
	@Output() typeChange: EventEmitter<any> = new EventEmitter();

	@Input() rowAccount: any = {};
	@Input() rowType = '';
	@Input() rowIndex = -1;
	@Input() disabledTime = false;
	@Input() disabledAccounts = false;
	@Input() disabledSTOT = false;

	canEditCustomType = false;

	constructor(
		public timesheetService: TimesheetService,
		public dataService: DataService,
		public accountService: AccountService,
		public configService: ConfigService
	) { }

	ngOnInit() {
		console.log('INIT SEARCHABLE TIMESHEET ROW', this.rowAccount);
		this.timesheetService.showAccountsResults = -1;
		this.canEditCustomType = this.configService.canEditCustomTimesheetLineItem(this.rowType);
	}

	autoSelectRow(data) {
		console.log('AUTO SELECT SEARCH ACCT ROW');
		const self = this;
		const delay = setTimeout(function () {
			self.rowClick({}, data, false);
		}, 400);
	}

	onFieldChange(event) {
		console.log('TIMESHEET ACCOUNT CHANGE');
		this.dataService.clearSearchAccounts();
		const self = this;
		const delay = setTimeout(function () {
			self.performSearch();
		}, 500);
		this.accountChange.emit({
			event: event,
			data: [this.rowAccount]
		});
	}

	onDescriptionChange(event) {
		this.accountChange.emit({
			event: event,
			data: [this.rowAccount],
			ilcValid: true
		});
	}

	performSearch(deepSearch = false) {
		this.timesheetService.showAccountsResults = this.rowIndex;
		console.log('SEARCH TIMESHEET ACCOUNTS', this.timesheetService.contractorId, this.rowAccount);
		let startDate = '';
		let contractorId = this.timesheetService.ilcSerial;
		if (contractorId === '' || contractorId === undefined) {
			console.log('USING CONTRACTOR ID - ILC SERIAL MISSING');
			contractorId = this.timesheetService.contractorId;
		}
		if (this.dataService.timesheetRows && this.dataService.timesheetRows[0] && this.dataService.timesheetRows[0][0]) {
			startDate = this.dataService.timesheetRows[0][0]['date'];
		}

		this.accountService.searchAccounts(this.rowAccount, contractorId, startDate, deepSearch);
	}

	inputClick(event) {
		const self = this;
		const delay = setTimeout(function () {
			if (self.hasSomething()) {
				self.performSearch();
			} else {
				self.dataService.clearSearchAccounts();
			}
		}, 300);
	}

	canDeepSearch() {
		let canSearch = false;
		if (this.rowAccount['accountid'] && this.rowAccount['accountid'].length > 1
			|| this.rowAccount['workitemid'] && this.rowAccount['workitemid'].length > 1) {
			canSearch = true;
		}
		return canSearch;
	}

	rowClick(event, row, hideResults = true) {
		this.rowAccount = _.cloneDeep(row);
		if (hideResults) {
			this.timesheetService.showAccountsResults = -1;
		}
		this.accountChange.emit({
			event: event,
			data: [this.rowAccount],
			ilcClick: true
		});
	}

	addRows() {
		this.timesheetService.showAccountsResults = -1;
		const selectedAccts = this.dataService.searchAccounts.filter(acct => {
			return acct.checked;
		});
		if (selectedAccts.length > 0) {
			this.accountChange.emit({
				event: event,
				data: selectedAccts,
				ilcClick: true
			});
		}
	}

	onCheck(event) {
		event.stopPropagation();
	}

	onTypeChange(event) {
		this.canEditCustomType = this.configService.canEditCustomTimesheetLineItem(this.rowType);
		this.typeChange.emit({
			event: event,
			data: this.rowType
		});
	}

	clearField(event, field) {
		this.rowAccount[field] = '';
		const self = this;
		const delay = setTimeout(function () {
			if (self.hasSomething()) {
				self.performSearch();
			} else {

			}
		}, 200);
	}

	clearInputs(event) {
		this.rowAccount['accountid'] = '';
		this.rowAccount['workitemid'] = '';
		this.rowAccount['workitemdescription'] = '';
		this.rowAccount['activitycode'] = '';
		this.rowAccount['activitydescription'] = '';
		this.rowAccount['billcode'] = '';
		this.dataService.clearSearchAccounts();
		this.accountChange.emit({
			event: event,
			data: [this.rowAccount]
		});
	}

	deepSearch(event) {
		console.log('TIMESHEET ACCOUNT DEEP SEARCH');
		this.dataService.clearSearchAccounts();
		const self = this;
		const delay = setTimeout(function () {
			self.performSearch(true);
		}, 500);
	}

	convertSTOT(stot) {
		const lowerCaseStOt = stot ? stot.toLowerCase() : '';
		return HourTypes[lowerCaseStOt];
	}

	hasAccount() {
		return this.rowAccount['accountid'] !== '' && this.rowAccount['accountid'] !== undefined && this.rowAccount['accountid'] !== null;
	}

	hasWorkitem() {
		return this.rowAccount['workitemid'] !== '' && this.rowAccount['workitemid'] !== undefined && this.rowAccount['workitemid'] !== null;
	}

	hasWorkitemDesc() {
		return this.rowAccount['workitemdescription'] !== ''
			&& this.rowAccount['workitemdescription'] !== undefined
			&& this.rowAccount['workitemdescription'] !== null;
	}

	hasActivityCode() {
		return this.rowAccount['activitycode'] !== '' && this.rowAccount['activitycode'] !== undefined && this.rowAccount['activitycode'] !== null;
	}

	hasActivityDescription() {
		return this.rowAccount['activitydescription'] !== ''
			&& this.rowAccount['activitydescription'] !== undefined
			&& this.rowAccount['activitydescription'] !== null;
	}

	hasBillCode() {
		return this.rowAccount['billcode'] !== '' && this.rowAccount['billcode'] !== undefined && this.rowAccount['billcode'] !== null;
	}

	hasSomething() {
		const hasSomething =
			this.hasAccount() || this.hasWorkitem() || this.hasWorkitemDesc() || this.hasActivityCode() || this.hasActivityDescription() || this.hasBillCode();
		return hasSomething;
	}

	allowSecondary() {
		let allowSecondary = false;
		if (this.hasWorkitem() || this.hasAccount()) {
			allowSecondary = true;
		}
		return allowSecondary;
	}
}
